import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { GetUserByIdFailure, GetUserByIdRequest, GetUserByIdSuccess } from './actions';
import { User } from '@models/swagger';

export const featureKey = 'getUserById';

export interface State {
  data: User | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GetUserByIdFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(GetUserByIdRequest, state => ({ ...state, error: null, loading: true })),
    on(GetUserByIdSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
